import { environment } from '~env/environment';

export const API_SELLER_OFFICE_V2 = `${environment.svcSellerOfficeBaseUrl()}/api/v2`;
